import React from "react";

// Material UI
import SvgIcon from "@material-ui/core/SvgIcon";

const LayerTypeRasterIcon = props => {
  return (
    <SvgIcon {...props} viewBox="-0.8 0 10 10">
      <path
        fill="currentColor"
        d="M1.2,8v2h-2V8H1.2z M5.2,8v2h-2V8H5.2z M9.2,8v2h-2V8H9.2z M3.2,6v2h-2V6H3.2z M7.2,6v2h-2V6H7.2z M1.2,4v2h-2V4H1.2z M5.2,4v2h-2V4H5.2z M9.2,4v2h-2V4H9.2z M3.2,2v2h-2V2H3.2z M7.2,2v2h-2V2H7.2z M1.2,0v2h-2V0H1.2z M5.2,0v2h-2V0H5.2z M9.2,0v2h-2V0H9.2z"
      />
    </SvgIcon>
  );
};

export default LayerTypeRasterIcon;
